export default __webpack_public_path__ + "static/media/yopy.f261ebf3.png";